<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t5Obad/tc-custom/9780226713533.jpg?1724858703640" alt="This image is the cover for the book Time and Narrative, Volume 3"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Time and Narrative, Volume 3
      </h1>
      <p class="bookDescription body article font2">
        <p>In the first two volumes of this work, Paul Ricoeur examined the relations between time and narrative in historical writing, fiction, and theories of literature. This final volume, a comprehensive reexamination and synthesis of the ideas developed in volumes 1 and 2, stands as Ricoeur's most complete and satisfying presentation of his own philosophy.<br/><br/> Ricoeur's aim here is to explicate as fully as possible the hypothesis that has governed his inquiry, namely, that the effort of thinking at work in every narrative configuration is completed in a refiguration of temporal experience. To this end, he sets himself the central task of determing how far a poetics of narrative can be said to resolve the "aporias"—the doubtful or problematic elements—of time. Chief among these aporias are the conflicts between the phenomenological sense of time (that experienced or lived by the individual) and the cosmological sense (that described by history and physics) on the one hand and the oneness or unitary nature of time on the other. In conclusion, Ricoeur reflects upon the inscrutability of time itself and attempts to discern the limits of his own examination of narrative discourse.<br/><br/> "As in his previous works, Ricoeur labors as an imcomparable mediator of often estranged philosophical approaches, always in a manner that compromises neither rigor nor creativity."—Mark Kline Taylor, <i>Christian Century</i><br/><br/> "In the midst of two opposing contemporary options—either to flee into ever more precious readings . . . or to retreat into ever more safe readings . . . —Ricoeur's work offers an alternative option that is critical, wide-ranging, and conducive to new applications."—Mary Gerhart, <i>Journal of Religion</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Ricoeur, Kathleen Blamey, David Pellauer
      </h2>
      
      <p class="authorDescription body article"><B>Paul Ricoeur</B> is the John Nuveen Professor Emeritus in the Divinity School, professor of philosophy, and a member of the Committee on Social Thought at the University of Chicago. He was for many years dean of the Faculty of Letters and Human Sciences at the University of Paris X (Nanterre).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98d84a60